import React from 'react';
import { DiscountPrice, Typography } from 'common/components';
import { CollectionPrice } from 'modules/collections';
import { formatToRub, removeSpecialCharacters } from 'utils/format';
import {
  productPriceContainer,
  productPrice,
  productPriceCredit,
  productPriceCurrency,
  productPriceWrapper,
} from './product-price-styles';

type ProductPriceProps = {
  currency?: string;
  pricePerQuantity?: boolean;
  prefix?: string;
  withCredit?: boolean;
} & Omit<CollectionPrice, 'cashback'>;

export const ProductPrice: React.FC<ProductPriceProps> = (
  { currency = '₽', discount, price, pricePerQuantity = true, prefix, prevPrice, withCredit = false }
) => (
  <div className={productPriceContainer}>
    <div className={productPriceWrapper} itemScope itemProp="offers" itemType="https://schema.org/Offer">
      {prefix && (
        <>
          <Typography
            adaptive={false}
            as="span"
            className={productPriceCurrency}
            variant="m"
            size="body_long">
            {prefix}
          </Typography>{' '}
        </>
      )}
      {(discount && prevPrice) && (
        <DiscountPrice
          discount={discount}
          price={prevPrice}
          size="l"
          showDiscountPlate
        />
      )}
      <Typography
        adaptive={false}
        as="span"
        color={discount ? 'secondary-red-primary' : 'text-primary'}
        className={productPrice}
        itemProp="price"
        content={`${price}.00`}
        variant="h2">
        {removeSpecialCharacters(formatToRub(price))}
      </Typography>{' '}
      <Typography
        adaptive={false}
        as="span"
        color={discount ? 'secondary-red-primary' : 'text-primary'}
        className={productPriceCurrency}
        content="RUB"
        itemProp="priceCurrency"
        variant="m"
        size="body_long">
        {currency}
      </Typography>
      {pricePerQuantity && (
        <Typography
          adaptive={false}
          as="span"
          color={discount ? 'secondary-red-primary' : 'text-primary'}
          className={productPriceCurrency}
          variant="m"
          size="body_long">
          /шт.
        </Typography>
      )}
    </div>
    {withCredit && (
      <Typography className={productPriceCredit} variant="caption_accent">
        от {formatToRub(Math.floor(price / 10))} ₽/мес
      </Typography>
    )}
  </div>
);
